// :cow: Cosmose CONFIDENTIAL :iso:
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import * as Chart from 'chart.js';
import { ChartData } from '../model/chart-data';

@Component({
  selector: 'coa-simple-line-chart',
  templateUrl: './simple-line-chart.component.html',
  styleUrls: ['./simple-line-chart.component.scss'],
})
export class SimpleLineChartComponent implements OnChanges, AfterViewInit {

  @Input() chartData: ChartData[];
  @ViewChild('chart', {read: ElementRef}) chartRef: ElementRef<HTMLCanvasElement>;
  isDatasetValid: boolean;
  chart: Chart;

  constructor(
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngAfterViewInit(): void {
    this.drawChart();
  }

  ngOnChanges(): void {
    this.drawChart();
  }

  private getContext(): CanvasRenderingContext2D {
    return this.chartRef.nativeElement.getContext('2d');
  }

  private drawChart(): void {
    this.isDatasetValid = !!this.chartData && this.chartData.length > 0;

    if (this.chart) {
      this.chart.destroy();
    }
    this.cdr.detectChanges();

    if (!this.isDatasetValid) {
      return;
    }

    this.chart = new Chart(this.getContext(), this.getChartOptions());
  }

  private getChartOptions(): any {
    return {
      type: 'line',
      data: {
        labels: this.getLabels(),
        datasets: [this.getChartjsDataset()],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
            },
            ticks: {
              display: false,
            },
          }],
          yAxes: [{
            gridLines: {
              display: false,
            },
            ticks: {
              display: false,
            },
          }],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
      },
    };
  }

  private getLabels(): undefined[] {
    return new Array(this.chartData.length);
  }

  private getChartjsDataset(): any {
    return {
      cubicInterpolationMode: 'default' as any,
      lineTension: 0.4,
      borderColor: 'white',
      borderWidth: 2,
      data: this.chartData.map(s => s.value),
      pointRadius: 0,
      fill: true,
      pointBackgroundColor: 'white',
      backgroundColor: this.getBackgroundGradient(),
    };
  }

  private getBackgroundGradient(): any {
    const gradient = this.getContext().createLinearGradient(0, 0, 0, 40);
    gradient.addColorStop(0, 'rgba(255, 255, 255, 0.5)');
    gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');

    return gradient;
  }

}
